import { computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ADMIN_ROLE, AuthService, BUSINESS_EXECUTIVE_ROLE, CUSTOMER_BASE_ACCESS_ROLE_GROUP } from '@zvoove-market/shared';

export const userCanManageTicketsGuard = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  return $userCanManageTickets(authService)() || router.parseUrl('/page-not-found');
};

export function $userCanManageTickets(authService: AuthService) {
  const permittedRoles = [ADMIN_ROLE, BUSINESS_EXECUTIVE_ROLE];
  return computed(
    () =>
      authService.$context().mandant?.roles.some((role) => permittedRoles.includes(role)) ||
      (authService.$context().mandant?.roles.some((role) => CUSTOMER_BASE_ACCESS_ROLE_GROUP.includes(role)) &&
        !!authService.$context().customer?.keyUserId)
  );
}
